import { render, staticRenderFns } from "./TabCategories.vue?vue&type=template&id=3b2f7918&scoped=true&"
import script from "./TabCategories.vue?vue&type=script&lang=js&"
export * from "./TabCategories.vue?vue&type=script&lang=js&"
import style0 from "./TabCategories.vue?vue&type=style&index=0&id=3b2f7918&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2f7918",
  null
  
)

export default component.exports